
import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { getLocalStorage } from '../../utils/localStorage';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export const SearchSuggestions = ({data, addToWatchlist}) => {
  const addedWatchedList = getLocalStorage("user").watchlist;
  return (
    <List sx={{ width: '100%', maxHeight: 300, overflow: 'hidden',maxWidth: 360, bgcolor: 'white', border: '1px solid black'}}>
      {data.map((el, i)=>
      <ListItem key={i}>
        <ListItemText primary={el.name} secondary={el.symbol} />
        <ListItemAvatar>
        
          <Avatar>
            {addedWatchedList?.includes(el.symbol) ? 
                   <CheckCircleIcon/>
            :  <AddCircleIcon onClick={$ => addToWatchlist(el.symbol)} />}
           
          </Avatar>
        </ListItemAvatar>
      </ListItem>)}
    </List>
  );
}
